
import AxiosAPI from "./AxiosAPI";

export const handleAddPaymentType = async (data) => {
  try {
    const response = await AxiosAPI.post("/setup/paymenttype", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add  payment type:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const handleEditPaymentType= async (data) => {  
  try {
    const response = await AxiosAPI.put(
      `/setup/paymenttype/${data.key}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const fetchPaymentTypes = async () => {
  try {
    const response = await AxiosAPI.get("/setup/paymenttype");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const deletePaymentType = async (key) => { 
  try {
    const response = await AxiosAPI.delete(
      `/setup/paymenttype/${key}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
    
  }
};

